/**
 * Created by odeds on 12/29/15.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var CONST = require("const");
    var StringFormats = require("utils/StringFormats");

    var Page = require("ui.components/page/Page");
    var ApiKeyEditView = require("manager-views/data-sources/api-keys/ApiKeyEditView");
    var ApiKeyModel = require("manager-models/data-sources/api-keys/ApiKeyModel");

    var ApiKeyEditController = {};



    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        ApiKeyEditController = Marionette.Controller.extend({
            pageView: null,
            insideView: null,
            apiModel: null,
            isModelChanged: false,
            needToRenderView: true,


            initialize: function(options) {
                this._initialize(options);
            },
            getMainView: function () {
                return this._getMainView();
            },
            show: function (appId) {
                this._show(appId);
            },


            _initialize: function(options) {
                LEManager.logger.info("initializing", "ApiKeyEditController:initialize");

                this.channel = LEManager.media.channel("apiKeyEdit");
                this._bindEvents();
            },

            _bindEvents: function() {
                LEManager.logger.debug("bind events to channel", "ApiKeyEditController:_bindEvents");

                this.listenTo(this.channel, "api:save", this._onApiSave);
                this.listenTo(this.channel, "api:close", this._onApiClose);
                this.listenTo(this.channel, "apiKey:change:privileges", this._onPrivilegesChange);
                this.listenTo(this.channel, "apiKey:change:name", this._onNameChange);
                this.listenTo(this.channel, "apiKey:change:description", this._onDescriptionChange);
                this.listenTo(this.channel, "apiKey:change:developerName", this._onDeveloperNameChange);
                this.listenTo(this.channel, "apiKey:change:active", this._onActiveStatusChange);
                this.listenTo(this.channel, "apiKey:change:ipRangesCollection:add", this._onIpRangesCollectionAdd);
                this.listenTo(this.channel, "apiKey:change:ipRangesCollection:close", this._onIpRangesCollectionClose);
                this.listenTo(this.channel, "apiKey:change:ipRangesCollection", this._onIpRangesCollectionChanged);
                this.listenTo(this.channel, "apiKey:ipRestrictionActivation:enabled", this._onIpRestrictionActivationEnabled);
                this.listenTo(this.channel, "apiKey:ipRestrictionActivation:disabled", this._onIpRestrictionActivationDisabled);

            },

            _getMainView: function() {
                LEManager.logger.debug("creating and returning the page view", "ApiKeyEditController:_getMainView");

                this._initPageView();
                return this.pageView;
            },

            _initPageView: function() {
                if (this.needToRenderView) {
                    if (this.pageView) {
                        this.pageView.close();
                    }
                    this.pageView = new Page({
                        moduleName: LEManager.moduleName,
                        context: LE.context,
                        permutation: Page.PERMUTATION.Dialog,
                        hasActionStrip: false,
                        header:{
                            knowledgePack: {text: LE.translator.translate("LEFramework.global.captions.learnMore"), eventId: "get-started-LE-APIs"},
                            description: LE.translator.translate("LEManager.manager.dataSources.Api_Keys.item.description")
                        }
                    });
                }
            },

            _show: function(apiKeyId) {
                LEManager.logger.info("show api edit", "ApiKeyEditController:_show", apiKeyId);

                this.isModelChanged = false;

                if (!this.needToRenderView) {
                    this.needToRenderView = true;
                    return;
                }

                //stop the once listeners incase they never occured
                this.stopListening(this.apiModel, "invalid");

                this._showLoader();

                if (apiKeyId === CONST.ROUTING.NEW_ITEM_ID) {
                    this._createNewApi();
                }
                else {
                    this._fetchApi(apiKeyId);
                }
            },

            _createNewApi: function() {
                this.apiModel = new ApiKeyModel();
                this._prepareAndShowEditView();
            },

            _fetchApi: function(apiKeyId) {
                this.apiModel = new ApiKeyModel({keyId:apiKeyId});
                this.apiModel.fetch({
                    success: _.bind(this._prepareAndShowEditView, this),
                    error:  _.bind(this._onFetchApiError, this)
                });
            },


            _onFetchApiError: function(apiModel, response, options) {
                this._closeLoader();
                LEManager.notifier.showError({content:LE.translator.translate("LEManager.manager.dataSources.Api_Keys.available.fetch.error"), timeToShow: 6000});
                LEManager.router.navigateBack();
            },
            _prepareAndShowEditView: function(){
                this.listModel = LEManager.getModuleDataManager().getData(LEManager.getModuleDataManager().getEntities().API_FULL_LIST);
                this.apiModel.initIpRangesCollection();
                this._showEditView();
            },
            _showEditView: function() {
                LEManager.logger.debug("initialize and show the app edit view in the page", "ApiKeyEditController:_showEditView");

                var title = LE.translator.translate("LEManager.manager.dataSources.Api_Keys.item." + (this.apiModel.isNew() ? "add" : "edit") + ".title");
                this.pageView.setTitle(title);

                this.insideView = new ApiKeyEditView({
                    model: this.apiModel,
                    channel: this.channel
                });
                this.pageView.setInsideView(this.insideView);

                this._closeLoader();
            },

            _saveApiKey: function(model){
                var isCreating= model.isNew();
                var options = {
                    success: _.bind(function (model, response, xhr) {
                        this._closeLoader();
                        if(isCreating){
                            var title = LE.translator.translate("LEManager.manager.dataSources.Api_Keys.item." + (this.apiModel.isNew() ? "add" : "edit") + ".title");
                            this.pageView.setTitle(title);
                        }else{
                            var message=  LE.translator.translate("LEManager.manager.dataSources.Api_Keys.item.saved");
                            LEManager.notifier.showSuccess({content: message, timeToShow: 6000});
                            LEManager.router.navigateBack();
                        }
                        this.channel.trigger("api:saved", isCreating);
                    }, this),
                    error: _.bind(function (model, response, options) {
                        this._closeLoader();
                        var message= LE.translator.translate("LEManager.manager.dataSources.Api_Keys.item.save.error");
                        if(response.status === 401){
                            message= LE.translator.translate("LEFramework.errors.serverError.1201");
                        }
                        LEManager.notifier.showError({content: message, timeToShow: 6000});
                    }, this)
                };
                this.listenToOnce(model,"invalid",function(){
                   this._closeLoader();
                });
                model.save(null, options);
            },

            _onApiSave: function(model) {
                this._showLoader();
                this._saveApiKey(model);
            },

            _onApiClose: function() {
                LEManager.router.navigateBack();
            },

            _onPrivilegesChange: function (privileges) {
                this.apiModel.setPrivileges(privileges);
            },

            _onNameChange: function (name) {
                this.apiModel.setName(name);
            },

            _onDescriptionChange: function (description) {
                this.apiModel.setDescription(description);
            },

            _onDeveloperNameChange: function (developerName) {
                this.apiModel.setDeveloperName(developerName);
            },

            _onActiveStatusChange: function (activeStatus) {
                this.apiModel.setActive(activeStatus);
            },

            _onIpRangesCollectionAdd: function(){
                this.apiModel.addIpRangeItem();
            },

            _onIpRangesCollectionClose: function (model) {
                this.apiModel.removeIpRangeItem(model);
            },

            _onIpRangesCollectionChanged: function(){
                this.apiModel.pullHierChangesToModel();
            },

            _onIpRestrictionActivationEnabled: function(){
                var ipRangesBackupArray = this.apiModel.getIpRangesBackupArray();
                this.apiModel.setIpRestrictionRanges(ipRangesBackupArray);

                //When the Ip Restriction is enabled it should contains at least one ip range, so if it's necessary we will add an empty one
                if (ipRangesBackupArray.length === 0) {
                    this.apiModel.addIpRangeItem();
                    this.apiModel.pullHierChangesToModel();
                }
            },

            _onIpRestrictionActivationDisabled: function(){
                this.apiModel.setIpRangesBackupArray();
                this.apiModel.clearIpRangesCollection();
            },

            _showLoader: function() {
                if (this.pageView) {
                    this.pageView.showLoader();
                }
            },

            _closeLoader: function() {
                if (this.pageView) {
                    this.pageView.closeLoader();
                }
            }

        });
    }

    LE.module("LEManager", moduleDefinition);

    return ApiKeyEditController;
});
